import {createSelector} from 'reselect';

const cart = state => state.cart;

export const selectCart = createSelector(cart, cartSelect => ({...cartSelect}));
